/**
 * React Query keys for quotes management
 */

export const queryKey = {
  getQuoteList: 'QUOTE_MANAGEMENT_GET_QUOTES_LIST',
  getQuoteDetail: 'QUOTE_MANAGEMENT_GET_QUOTE_DETAIL',
  getQuoteStatistics: 'QUOTE_MANAGEMENT_GET_STATISTICS',
  getQuoteStats: 'QUOTE_MANAGEMENT_GET_QUOTE_STATS',
  getQuoteCountByStatus: 'QUOTE_MANAGEMENT_GET_QUOTE_COUNT_BY_STATUS',
  getAllQuoteCountsByStatus: 'QUOTE_MANAGEMENT_GET_ALL_QUOTE_COUNTS_BY_STATUS',
  getQuoteResponseDetails: 'QUOTE_MANAGEMENT_GET_QUOTE_RESPONSE_DETAILS',
  getQuoteImage: 'QUOTE_MANAGEMENT_GET_QUOTE_IMAGE',
  getTotalQuotesCount: 'QUOTE_MANAGEMENT_GET_TOTAL_QUOTES_COUNT',
  getTotalQuotesValue: 'QUOTE_MANAGEMENT_GET_TOTAL_QUOTES_VALUE',
  getActivityLogs: 'QUOTE_MANAGEMENT_GET_ACTIVITY_LOGS',
  getQuoteLineItems: 'QUOTE_MANAGEMENT_GET_QUOTE_LINE_ITEMS',
  getSubQuoteProducts: 'QUOTE_MANAGEMENT_GET_SUB_QUOTE_PRODUCTS',
  getNotes: 'QUOTE_MANAGEMENT_GET_NOTES',
};
